<template>
<div class="chapter">
<div class="inner_page">
<h1>MAKING MIDCENTURY MODERN</h1>
<div class="toc">
<p>
<b>Table of Contents</b>
</p>
<dl>
<dt>
<span class="chapter">
<a href="#/ch01">Foreword</a>
</span>
</dt>
<dt>
<span class="chapter">
<a href="#/ch02">Introduction</a>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch03" title="Link target outside of Sample">Acknowledgments</span>
</span>
</dt>
</dl>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01toc.vue?215a478a